import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HelperService } from "@app/core/services/helper.service";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { ResultStatus } from "@app/core/models/result-status";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-message-detail",
  templateUrl: "./message-detail.component.html",
  styleUrls: ["./message-detail.component.scss"],
})
export class MessageDetailComponent implements OnInit {
  @ViewChild("deleteMessageTemplate") deleteMessageTemplate: ElementRef;
  modalRef: BsModalRef;

  messageId: any;
  messageItem: any;
  isDataLoaded = false;
  deleteId: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private messageCenterService: MessageCenterService,
    private modalService: BsModalService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.messageId = param.id;
    });
  }

  ngOnInit() {
    this.getMessageById();
  }

  getMessageById() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.messageId)) {
      this.messageCenterService
        .getMessagesById(this.messageId)
        .subscribe((result) => {
          this.isDataLoaded = true;
          if (result.Status === ResultStatus.Success) {
            this.messageItem = result.Data;
          } else {
            this.messageItem = [];
          }
        });
    }
  }

  openDeleteConfirmation(id) {
    this.deleteId = id;
    this.modalRef = this.modalService.show(
      this.deleteMessageTemplate,
      Object.assign({}, { class: "custom-modal update-modal modal-lg" })
    );
  }

  deleteMessage() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.deleteId)) {
      this.messageCenterService.deleteMessage(this.deleteId).subscribe((result) => {
        this.modalRef.hide();
        if (result.Status === ResultStatus.Success) {
          this.router.navigate(["messages"]);
        }
      });
    }
  }
}

